import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

@connect(mapStateToProps)
@withRouter
class AuthLayout extends React.PureComponent {
  render() {
    const {
      children,

      isBorderless,
      authPagesColor,
    } = this.props
    return (
      <Layout>
        <Layout.Content>
          <div
            className={classNames(`${style.container}`, {
              cui__layout__borderless: isBorderless,
              [style.white]: authPagesColor === 'white',
              [style.gray]: authPagesColor === 'gray',
            })}
            style={{
              backgroundImage:
                authPagesColor === 'image' ? 'url(resources/images/content/photos/7.jpg)' : '',
            }}
          >
            <div className={style.customcontainerInner}>{children}</div>
            <div className="mt-auto"></div>
          </div>
        </Layout.Content>
      </Layout>
    )
  }
}

export default AuthLayout
